import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Modal, Form, Button, Row, Col, Alert } from 'react-bootstrap';
import CreatableSelect from 'react-select/creatable';
import { useAuth } from '../context/AuthContext';
import { API_BASE } from '../utils/api';

const ModalNovoUsuario = ({ show, onHide, setUsuarios, usuarios, cargos, isDemo }) => {
  const { token } = useAuth();
  const { register, handleSubmit, setValue, watch, reset } = useForm({ defaultValues: { acesso: 'colaborador' } });
  const [telefone, setTelefone] = useState('');
  const [cargo, setCargo] = useState(null);
  const [cargoExcecao, setCargoExcecao] = useState(null);
  const [senhaPadrao, setSenhaPadrao] = useState(null);
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const clearPhone = (v) => v.replace(/\D/g, '');
  const formatPhone = (v) => {
    const n = clearPhone(v || '');
    return n.length === 11 ? `(${n.slice(0, 2)}) ${n[2]} ${n.slice(3, 7)}-${n.slice(7)}` : v || '';
  };

  const onSubmit = async (data) => {
    const payload = {
      nome: data.nome.toUpperCase(),
      cargo: (cargo?.value || '').toUpperCase(),
      cargo_excecao: (cargoExcecao?.value || '').toUpperCase() || null,
      condicao_tipo_conteudo: data.condicao_tipo_conteudo || null,
      numero_telefone: clearPhone(telefone),
      acesso: data.acesso,
      gerente_percentual: data.acesso === 'gerente' ? Math.max(0, Math.min(100, parseFloat(data.gerente_percentual ?? 30))) : 0
    };

    if (isDemo) {
      const novoUsuario = { ...payload, id: Date.now() };
      setUsuarios([...usuarios, novoUsuario]);
      handleClose();
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/users/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        const result = await res.json();
        setUsuarios([...usuarios, { ...payload, id: result.id }]);
        if (result.senha_padrao) setSenhaPadrao(result.senha_padrao);
        else handleClose();
      } else {
        const result = await res.json();
        setErro(result.message || 'Erro ao cadastrar usuário.');
      }
    } catch (err) {
      setErro('Erro ao conectar com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    reset();
    setTelefone('');
    setCargo(null);
    setCargoExcecao(null);
    setSenhaPadrao(null);
    setErro('');
    onHide();
  };

  const cargoOptions = [...new Set(cargos)].sort().map(c => ({ label: String(c).toUpperCase(), value: String(c).toUpperCase() }));
  const tiposVideo = process.env.REACT_APP_OPTIONS_TIPOS?.split(',') || ['SHORT', 'LONGO'];
  const acessoAtual = watch('acesso');

  if (senhaPadrao) {
    return (
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title><i className="bi bi-check-circle-fill me-2 text-success"></i>Usuário Criado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="success" className="border-0">
            <div className="fw-bold mb-1">Cadastro realizado com sucesso!</div>
            <div className="small">O usuário foi criado com a senha padrão abaixo. Oriente-o a alterá-la no primeiro acesso.</div>
          </Alert>
          <div className="p-3 rounded-3 text-center" style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0' }}>
            <div className="small text-muted mb-1">Senha padrão</div>
            <div className="fw-bold fs-4" style={{ letterSpacing: '2px', fontFamily: 'monospace' }}>{senhaPadrao}</div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="primary" className="w-100 border-0 fw-bold" style={{ backgroundColor: 'var(--brand-primary)' }} onClick={handleClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title><i className="bi bi-person-plus-fill me-2 text-primary"></i>Novo Usuário</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {erro && <Alert variant="danger" className="border-0 mb-3">{erro}</Alert>}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="small fw-bold">NOME COMPLETO</Form.Label>
                <Form.Control {...register('nome', { required: true })} onChange={(e) => setValue('nome', e.target.value.toUpperCase())} />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="small fw-bold">TELEFONE</Form.Label>
                <Form.Control value={telefone} onChange={(e) => setTelefone(formatPhone(e.target.value))} placeholder="(00) 0 0000-0000" />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold">CARGO PRINCIPAL</Form.Label>
            <CreatableSelect
              isClearable
              options={cargoOptions}
              value={cargo}
              onChange={(opt) => setCargo(opt)}
              onCreateOption={(input) => setCargo({ label: input.toUpperCase(), value: input.toUpperCase() })}
              placeholder="Selecione o cargo padrão..."
            />
          </Form.Group>

          <div className="p-3 mb-3 rounded-3" style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0' }}>
            <h6 className="text-primary small fw-bold mb-3"><i className="bi bi-lightning-fill me-1"></i>REGRA DE EXCEÇÃO (OPCIONAL)</h6>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="extra-small fw-bold text-muted">CARGO ESPECIAL</Form.Label>
                  <CreatableSelect
                    isClearable
                    options={cargoOptions}
                    value={cargoExcecao}
                    onChange={(opt) => setCargoExcecao(opt)}
                    onCreateOption={(input) => setCargoExcecao({ label: input.toUpperCase(), value: input.toUpperCase() })}
                    placeholder="Ex: DESENHISTA"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="extra-small fw-bold text-muted">QUANDO O VÍDEO FOR...</Form.Label>
                  <Form.Select {...register('condicao_tipo_conteudo')}>
                    <option value="">NUNCA (USAR PADRÃO)</option>
                    {tiposVideo.map(t => <option key={t} value={t.trim()}>{t.trim().toUpperCase()}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </div>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="small fw-bold">NÍVEL DE ACESSO</Form.Label>
                <Form.Select {...register('acesso', { required: true })}>
                  <option value="admin">Admin</option>
                  <option value="analista">Analista</option>
                  <option value="colaborador">Colaborador</option>
                  <option value="gerente">Gerente</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {acessoAtual === 'gerente' && (
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold">REPASSE (%)</Form.Label>
                  <Form.Control type="number" step="0.1" {...register('gerente_percentual')} defaultValue={30} />
                </Form.Group>
              </Col>
            )}
          </Row>

          <Button type="submit" className="w-100 border-0 mt-3 py-2 fw-bold" style={{ backgroundColor: 'var(--brand-primary)' }} disabled={loading}>
            {loading
              ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</>
              : <><i className="bi bi-check-circle me-2"></i>Concluir Cadastro</>}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalNovoUsuario;